export const shouldShowBudgetPopup = (exibirPopup: boolean, alreadySeenThisSession: boolean) =>
  exibirPopup && !alreadySeenThisSession
